import { CreditCard, Smartphone, Apple } from "lucide-react";

// Iteration 6: ALL transactions flow through Hoomanz/Stripe. Bank + crypto removed.
export const PAYMENT_METHODS = [
  { id: "card",       label: "Credit/Debit Card", Icon: CreditCard, safe: true },
  { id: "apple_pay",  label: "Apple Pay",          Icon: Apple,      safe: true },
  { id: "google_pay", label: "Google Pay",         Icon: Smartphone, safe: true },
];

export const PAYMENT_MAP = Object.fromEntries(PAYMENT_METHODS.map(p => [p.id, p]));
export const SAFE_METHODS = new Set(["card","apple_pay","google_pay"]);
// 2 % "Hoomanz Tip" — added ON TOP of the seller's price at checkout.
// Sellers receive 100 % of their listed price; the tip goes to the platform.
export const PLATFORM_FEE_RATE = 0.02;
